
<template>
    <div>
        <div class="page-filter-box">
            <el-row :gutter="20">
                <el-col :xs="24" :sm="12" :md="7" :lg="8" :xl="4">
                    <el-input v-model="params.searchValue" class="input-with-select" size="small">
                        <el-select v-model="params.searchType" slot="prepend" placeholder="请选择">
                            <el-option label="结款方ID" :value="1"></el-option>
                            <el-option label="结款方名称" :value="2"></el-option>
                            <el-option label="合同编号" :value="3"></el-option>
                        </el-select>
                    </el-input>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="6" :xl="4">
                    <el-select v-model="params.status" placeholder="请选择结款单状态" size="small">
                        <el-option label="不限结款单状态" value=""></el-option>
                        <el-option label="仅看待结款的" :value="1"></el-option>
                        <el-option label="仅看已结款的" :value="2"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="12" :lg="11" :xl="8">
                    <div class="clearfix timeType">
                        <el-input class="input-with-select fl" size="small">
                            <el-select v-model="params.timeType" slot="prepend" placeholder="请选择">
                                <el-option label="销售周期" :value="1"></el-option>
                                <el-option label="打款时间" :value="2"></el-option>
                            </el-select>
                        </el-input>
                        <el-date-picker
                            v-model="datetimerange"
                            type="datetimerange"
                            start-placeholder="开始时间"
                            end-placeholder="结束时间"
                            class="fl"
                            size="small"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            :default-time="['00:00:00', '23:59:59']"
                            unlink-panels
                            >
                        </el-date-picker>
                    </div>
                </el-col>
                <el-col :xs="24" :sm="12" :md="5" :lg="5" :xl="4" class="page-filter-btns">
                    <el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
                    <el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
                </el-col>
            </el-row>
        </div>
        <div class="page-list-box">
            <el-table
                :data="dataList"
                border
                style="width: 100%"
                v-loading="listLoading"
                size="small"
                stripe
            >
                <el-table-column prop="id" label="结款单ID"></el-table-column>
                <el-table-column prop="status" label="结款单状态" min-width="90">
                    <template slot-scope="scope">{{scope.row.status == 1 ? '待结款' : '已结款'}}</template>
                </el-table-column>
                <el-table-column prop="refundNum" label="已结款退款数量" min-width="110"></el-table-column>
                <el-table-column prop="refundAmount" label="已结款退款金额" min-width="110"></el-table-column>
                <el-table-column prop="applyUserType" label="结款方身份" min-width="90">
                    <template slot-scope="scope">{{$userType.get(scope.row.applyUserType)}}</template>
                </el-table-column>
                <el-table-column prop="applyUserId" label="结款方ID"></el-table-column>
                <el-table-column prop="applyUserName" label="结款方名称" min-width="100" show-overflow-tooltip></el-table-column>
                <el-table-column label="销售截止" min-width="170">
                    <template slot-scope="scope">
                        <!-- 起:{{scope.row.applyStartTime}}<br/>止: -->
                        {{scope.row.applyEndTime}}
                    </template>
                </el-table-column>
                <el-table-column prop="saleNum" label="销售商品数" min-width="90"></el-table-column>
                <el-table-column prop="saleAmountFormat" label="销售金额"></el-table-column>
                <!-- <el-table-column prop="platDiscountFormat" label="秀动承担优惠" min-width="100"></el-table-column> -->
                <el-table-column prop="busDiscountFormat" label="商家承担优惠" min-width="100"></el-table-column>
                <el-table-column prop="serviceFeePercentage" label="服务费率"></el-table-column>
                <el-table-column prop="serviceFeeAmountFormat" label="服务费用"></el-table-column>
                <el-table-column prop="playPriceTicketFormat" label="实际打款金额" min-width="100"></el-table-column>
                <el-table-column prop="playTime" label="打款时间" min-width="150"></el-table-column>
                <el-table-column prop="contractSn" label="合同编号" min-width="120"></el-table-column>
                <el-table-column fixed="right" label="操作" width="170">
                    <template slot-scope="scope">
                        <el-button
                            v-if="$utils.have('/goodsReceivablesAudit/audi/audi')"
                            type="text"
                            size="small"
                            icon="el-icon-tickets"
                            @click="$refs.dataView.show(scope.row)"
                            >结款信息</el-button>
                        <el-button
                            v-if="$utils.have('/goodsReceivablesAudit/audi/sale/statistic')"
                            type="text"
                            size="small"
                            icon="el-icon-view"
                            @click="view(scope.row)"
                            >收入明细</el-button>    
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div v-if="data" class="page-pagination-box">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="getDataList"
                :current-page.sync="params.pageNo"
                :page-sizes="$pageSizes"
                :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="data.totalCount || 0">
            </el-pagination>
        </div>
        <DataView ref="dataView" @onUpdate="getDataList"></DataView>
    </div>
</template>

<script>
import DataView from './components/dataView';
const defaultParams = {
    pageNo: 1,
    searchType: 1,
    searchValue: '',
    timeType:  1 ,
    timeFrom:  null,
    timeTo: null,
    status: ""
}
export default {
    components:{DataView},
    data(){
        return{
            data: null,
            dataList: null,
            params:{
                ...defaultParams,
                pageNo: parseInt(this.$route.query.pageNo || 1),
                pageSize: parseInt(this.$route.query.pageSize || this.$pageSizes[0]),
                searchType: parseInt(this.$route.query.searchType || 1),
                searchValue: this.$route.query.searchValue || '',
                timeType:  parseInt(this.$route.query.timeType || 1) ,
                timeFrom: this.$route.query.timeFrom || null,
                timeTo: this.$route.query.timeTo || null,
                status: parseInt(this.$route.query.status)  || "",
            },
            datetimerange:[this.$route.query.timeFrom || '' , this.$route.query.timeTo || ''],
            listLoading: true,
        }
    },
    mounted() {
        this.getDataList();
    },
    methods:{
        //获取列表
        getDataList() {
            this.listLoading = true;
            this.params = {
                ...this.params,
                timeFrom:this.datetimerange && this.datetimerange[0] || null,
                timeTo:this.datetimerange && this.datetimerange[1] || null
            }
            this.$request({
                url: "/goodsReceivablesAudit/audi/list",
                method: "POST",
                data: this.params,
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                        this.data = result;
                        this.dataList = result.result || [];
                    } else {
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.listLoading = false;
                });
        },
        //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
        },
        //搜索
        search() {
            this.params.pageNo = 1;
            this.getDataList();
        },
        //重置搜索
        reset() {
            this.datetimerange = [];
            this.params = {
                ...defaultParams,
                pageSize: this.params.pageSize,
            };
            this.getDataList();
        },
        view(data){
            this.$router.push({
                path: `/finance/goods/settlement/detail/${data.id}/${data.applyUserId}`,
                query: {
                    redirect: this.$utils.objArgs(
                        this.$router.currentRoute.path,
                        this.params
                    ),
                },
            });
        }
    }
}
</script>